import { trpc } from '@/api/tRpc';
import { STALE_LONG, STALE_MEDIUM } from '@/lib/query-options';

/**
 * Hook to fetch all available tables for a specific retailer/environment.
 *
 * @param { string | undefined } retailerCode The retailer code.
 * @param { string | undefined } environment The environment name.
 * @returns { object } Returns tRPC query result with tables list.
 */
export const useTables = (retailerCode: string | undefined, environment: string | undefined) => {
  return trpc.sourceTables.list.useQuery(
    { environment: environment ?? '', retailerCode: retailerCode ?? '' },
    {
      staleTime: STALE_LONG,
      enabled: !!retailerCode && !!environment,
    },
  );
};

/**
 * Hook to fetch columns for a specific source table.
 *
 * @param { string | undefined } retailerCode The retailer code.
 * @param { string | undefined } environment The environment name.
 * @param { string | undefined } tableName The source table name to fetch columns for.
 * @returns { object } Returns tRPC query result with table columns.
 */
export const useTableColumns = (
  retailerCode: string | undefined,
  environment: string | undefined,
  tableName: string | undefined,
) => {
  return trpc.sourceTables.getColumns.useQuery(
    { tableName: tableName ?? '', environment: environment ?? '', retailerCode: retailerCode ?? '' },
    {
      staleTime: STALE_MEDIUM,
      enabled: !!retailerCode && !!environment && !!tableName,
    },
  );
};
